import { c as _c } from "react/compiler-runtime";
import { LoanLightLoading } from "@/components/LoanLightLoading";
import { FC } from "react";
interface LoadingModalProps {
  title: string;
  subTitle?: string;
  message?: string;
  size: "small" | "medium" | "large";
}
export const LoadingModal: FC<LoadingModalProps> = t0 => {
  const $ = _c(12);
  const {
    title,
    subTitle,
    message,
    size
  } = t0;
  const t1 = `bg-white rounded-lg shadow-lg p-8 flex flex-col items-center justify-center gap-4 max-w-[90vw] max-h-[90vh] ${size === "small" ? "min-w-[200px] min-h-[120px]" : size === "medium" ? "min-w-[300px] min-h-[160px]" : "min-w-[400px] min-h-[200px]"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LoanLightLoading />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <h2 className="text-2xl font-medium text-gray-900 text-center">{title}</h2>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== subTitle) {
    t4 = subTitle && <h3 className="text-base font-normal text-gray-700 text-center mt-2">{subTitle}</h3>;
    $[3] = subTitle;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== message) {
    t5 = message && <p className="text-base font-normal text-gray-600 text-center leading-6 tracking-tight">{message}</p>;
    $[5] = message;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="fixed top-0 left-0 right-0 bottom-0 bg-opacity-50 flex items-center justify-center z-50"><div className={t1} onClick={_temp}>{t2}{t3}{t4}{t5}</div></div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(e) {
  return e.stopPropagation();
}